// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2ujRt","tab":"Tabs_tab__1SaZs","tabActive":"Tabs_tabActive__2CjsC"};